<div class="document-preview-status" *ngIf="loading">{{ loadingMessage }}</div>
<div class="document-preview-status" *ngIf="!loading && errorMessage">{{ errorMessage }}</div>
<iframe *ngIf="pdfUrl as url"
        class="document-preview-frame"
        [class.document-preview-frame-compact]="compact"
        [src]="url"
        [title]="'Anteprima di ' + fileName"></iframe>
<img *ngIf="imageUrl"
     class="document-preview-image"
     [src]="imageUrl"
     [alt]="fileName">
<div #docxHost
     *ngIf="kind === 'docx' && !errorMessage"
     class="document-preview-docx"></div>
<p *ngIf="downloadError" class="document-preview-download-error">{{ downloadError }}</p>
